import BotResponseTreeNode from './BotResponseTreeNode';

class GenerativeAiTreeNode {
  nextStep: BotResponseTreeNode | null;

  constructor(nextStep: BotResponseTreeNode | null) {
    this.nextStep = nextStep;
  }
}

export default GenerativeAiTreeNode;
